import Vue from 'vue'
import VueRouter from 'vue-router'
import CheckVoterList from '../views/Check-voter-list.vue'
import Step1 from '../views/Register-to-vote-step-1.vue'
import Step2 from '../views/Register-to-vote-step-2.vue'
import Step3 from '../views/Register-to-vote-step-3.vue'
import Step4 from '../views/Register-to-vote-step-4.vue'
import Step5 from '../views/Register-to-vote-step-5.vue'
import SealedEnvelopeBallot from '@/views/Sealed-Envelope-Ballot.vue'
import SealedEnvelopeBallotStep1 from '@/views/Sealed-envelope-ballot-step-1.vue'
import SealedEnvelopeBallotStep2 from '@/views/Sealed-envelope-ballot-step-2.vue'
import SealedEnvelopeBallotStep3 from '@/views/Sealed-envelope-ballot-step-3.vue'
import SealedEnvelopeBallotStep4 from '@/views/Sealed-envelope-ballot-step-4.vue'
import SealedEnvelopeBallotStep5 from '@/views/Sealed-envelope-ballot-step-5.vue'
import WhereDoIVote from '@/views/Where-do-i-vote.vue'
import ShowVotingLocations from '@/views/Show-Voting-Locations.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: CheckVoterList
    },
    {
        path: '/where-do-i-vote',
        name: 'WhereDoIVote',
        component: WhereDoIVote
    },
    {
        path: '/show-voting-locations/:address_id',
        name: 'ShowVotingLocations',
        component: ShowVotingLocations
    },
    {
        path: '/register-to-vote-step-1/:page_type?/:voter_id?',
        name: 'Step1',
        component: Step1
    },
    {
        path: '/register-to-vote-step-2/:page_type?/:voter_id?',
        name: 'Step2',
        component: Step2
    },
    {
        path: '/register-to-vote-step-3/:page_type?/:voter_id?',
        name: 'Step3',
        component: Step3
    },
    {
        path: '/register-to-vote-step-4/:page_type?/:voter_id?',
        name: 'Step4',
        component: Step4
    },
    {
        path: '/register-to-vote-step-5/:page_type?/:voter_id?/:registration_id?',
        name: 'Step5',
        component: Step5
    },
    {
        path: '/sealed-envelope-ballot',
        name: 'SealedEnvelopeBallot',
        component: SealedEnvelopeBallot
    },
    {
        path: '/sealed-envelope-ballot-step-1/:page_type?/:voter_id?/:registration_id?',
        name: 'SealedEnvelopeBallotStep1',
        component: SealedEnvelopeBallotStep1
    },
    {
        path: '/sealed-envelope-ballot-step-2/:page_type?/:voter_id?/:registration_id?',
        name: 'SealedEnvelopeBallotStep2',
        component: SealedEnvelopeBallotStep2
    },
    {
        path: '/sealed-envelope-ballot-step-3/:page_type?/:voter_id?/:registration_id?',
        name: 'SealedEnvelopeBallotStep3',
        component: SealedEnvelopeBallotStep3
    },
    {
        path: '/sealed-envelope-ballot-step-4/:page_type?/:voter_id?/:registration_id?',
        name: 'SealedEnvelopeBallotStep4',
        component: SealedEnvelopeBallotStep4
    },
    {
        path: '/sealed-envelope-ballot-step-5',
        name: 'SealedEnvelopeBallotStep5',
        component: SealedEnvelopeBallotStep5
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

export default router
